module.exports = __webpack_public_path__ + "img/上銀科技.705d8181.png";